export enum EPublishOfferStatus {
  Initial = 'initial',
  Pending = 'pending',
  Success = 'success',
  Fail = 'fail',
}

export enum EPublishOfferErrorCode {
  /** неверный запрос */
  badRequest = 'badRequest',
  /** неизвестная ошибка на сервере */
  fatalError = 'fatalError',
  /** ошибка валидации */
  validationError = 'validationError',
}
